import { Controller } from "react-hook-form";
import { FormHelperText, FormLabel, TextField } from "@material-ui/core";

import { useFormControlStyles } from "../form-control.styles";
import { IDatepicker } from "./date-picker.props";

export const Datepicker = (props: IDatepicker) => {
  const classes = useFormControlStyles();

  const hasError = props.form.formState.errors ? !!props.form.formState.errors[props.name] : false;
  const errorMessage = hasError ? props.form.formState.errors![props.name].message! : "";

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(controlProps) => (
        <label className={classes.wrapper}>
          <FormLabel
            className={classes.label}
            error={hasError}
            required={props.required}
            component="span"
          >
            {props.label}
          </FormLabel>
          <TextField
            {...controlProps.field}
            error={hasError}
            size="small"
            type="date"
            variant="outlined"
            placeholder="yyyy-mm-dd"
          />
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
